// extracted by mini-css-extract-plugin
export default {"root":"SectionAuthorCustom_root__0iMjp","wrapper":"SectionAuthorCustom_wrapper__NpAtG","authorName":"SectionAuthorCustom_authorName__l+2Ss"};